import styled from 'styled-components';

export const StyledCopyIprIdToQaPresentation = styled.div`
  h2 {
    color: red;
  }
  h3 {
    color: green;
  }
`;
